import React, { useState, useEffect, useRef } from 'react'
import { NavLink, useHistory, useParams } from 'react-router-dom'
import { Game5Map, getRndFromArray, useStore, GameStatus, shuffleArray, Game8Map } from '../lib'
import { Guide, Image as Img, Loader, ModalAlert, ModalImage, ScoreStats, SideNav } from '../components'
import { CSSTransition, TransitionGroup } from 'react-transition-group'
import { GameFrame } from './GameFrame'

export const Game5 = () => {
  const [isInitialized, setIsInitialized] = useState<boolean>(false)
  const [isFinished, setIsFinished] = useState<boolean>(false)
  const [imgWidth, setImgWidth] = useState<number>(window.innerWidth * 0.42)
  const [selectedImage, setSelectedImage] = useState<any>(null)
  const [answers, setAnswers] = useState<string[]>([])
  const [clipStates, setClipStates] = useState<any>({})
  const [gameStartTime, setGameStartTime] = useState<number>(+new Date())
  const [gameEndTime, setGameEndTime] = useState<number>()
  const history = useHistory()
  const refGuide: any = useRef(null)
  const refModalAlert: any = useRef(null)
  const refModalImage: any = useRef(null)
  // const { id }: any = useParams()
  const { state, patchState } = useStore()

  const preloadImages = async () => {
    const onImgLoad = async (imageEl: HTMLImageElement) => {
      return new Promise(resolve => {
        imageEl.onload = () => resolve(imageEl)
      })
    }
    const all = [...Game5Map.items].map(a => a.img)
    for (const imgSrc of all) {
      const img = new Image()
      img.src = imgSrc
      await onImgLoad(img)
    }
    const current = getRndFromArray([...Game5Map.items])
    setSelectedImage(current)
    setAnswers(shuffleArray([...current.falseAnswers, current.label]))
    setIsInitialized(true)
    // console.warn(current, shuffleArray([...current.falseAnswers, current.label])); // TODO: remove
    return true
  }

  useEffect(() => {
    if (!isInitialized) {
      preloadImages()
      patchState({ score: 0, errors: 0 }) // todo
    } else {
      refGuide?.current?.openModal(Game5Map.intro)
    }
  }, [isInitialized])

  const onAnswer = (id: string, clipPathId?: string) => {
    // console.warn(id, selectedImage.label, selectedImage.label === id); // TODO: remove
    if (selectedImage.label === id) {
      // patchState({ score: state.score + 1 }) // todo how to score this game??
      // 6bodu zacatek, postupne odecitat chyby
      onGameEnd()
    } else {
      if (id !== '') {
        refGuide?.current?.openModal([getRndFromArray(Game8Map.errorComments)])
        patchState({ errors: state.errors + 1 })
      }
      if (clipPathId) {
        setClipStates({ ...clipStates, [clipPathId]: true })
        patchState({ errors: state.errors + 1 })
      }
      // setClipPath(Game5Map.clipPaths[Math.min(state.errors + 1, 5)]);
    }
  }

  const onGameEnd = () => {
    refGuide?.current?.openModal([selectedImage.correctMsg])
    const timeMs = +new Date() - gameStartTime
    patchState({
      timeMs: state.timeMs + timeMs,
      score: state.score + 1,
      games: { ...state.games, game5: { score: state.score + 1, errors: state.errors, timeMs } },
    })
    setAnswers([])
    setGameEndTime(+new Date())
    refGuide.current?.playSound()
    refGuide?.current?.onGameEnd(state.errors)
    setIsFinished(true)
  }

  const exitGame = () => {
    setSelectedImage(null)
    setAnswers([])
    setIsInitialized(false)
    setTimeout(() => history.push('/dashboard'))
  }

  if (!isInitialized || !answers) {
    return <Loader />
  }
  return (
    <div className="view background-winter">
      <div className="view-content p-5 text-black">
        <h1 className="text-3xl text-center font-bold w-full">Lesní plody</h1>
        <ScoreStats
          isCompact={true}
          isTimeShown={true}
          startTime={gameStartTime}
          endTime={gameEndTime}
          customScore={state.score}
          customErrors={state.errors}
        />
        <SideNav customScore={state.score} customErrors={state.errors} customText={Game5Map.intro} />
        <Guide ref={refGuide} isWinter={true} hasWinterGearA={true} hasWinterGearB={true} />
        <GameFrame
          isFinished={isFinished}
          onExit={exitGame}
          childrenLeft={
            <div
              onClick={() => onAnswer('')}
              className="w-full h-full"
              style={{
                backgroundImage: `url(${selectedImage.img})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'contain',
                backgroundPosition: 'center',
              }}
            >
              {/*<img src={selectedImage.img} style={{ width: '100%', clipPath, userSelect: 'none' }} alt=""/>*/}
              <div className="w-full h-full absolute flex flex-wrap">
                <div
                  className={`game5imgClip ${clipStates.a ? 'game5imgClipActivated' : ''}`}
                  onClick={() => onAnswer('', 'a')}
                />
                <div
                  className={`game5imgClip ${clipStates.b ? 'game5imgClipActivated' : ''}`}
                  onClick={() => onAnswer('', 'b')}
                />
                <div
                  className={`game5imgClip ${clipStates.c ? 'game5imgClipActivated' : ''}`}
                  onClick={() => onAnswer('', 'c')}
                />
                <div
                  className={`game5imgClip ${clipStates.d ? 'game5imgClipActivated' : ''}`}
                  onClick={() => onAnswer('', 'd')}
                />
                <div
                  className={`game5imgClip ${clipStates.e ? 'game5imgClipActivated' : ''}`}
                  onClick={() => onAnswer('', 'e')}
                />
              </div>

              {/*<img src={selectedImage.img} style={{ width: '100%', clipPath, userSelect: 'none', position: 'relative', top: 0, bottom: 0, left: 0, right: 0 }} alt=""/>*/}
            </div>
          }
          childrenRight={answers.map(a => (
            <div key={a} className={`btn btn-block mb-5 glass text-black shadow-xl`} onClick={() => onAnswer(a)}>
              {a}
            </div>
          ))}
        />
        <div>
          <ModalAlert ref={refModalAlert} />
        </div>
        <div>
          <ModalImage ref={refModalImage} />
        </div>
      </div>
    </div>
  )
}
